// action 类型定义
export const TREE_TYPE = {
  SETTREELIST: 'set_treeList',
  GET_TREE_DATA: 'get_treeList',
  SET_TREE_LOADING: 'SET_TREE_LOADING',
}
export interface treeItem {
  id: string
  name: string
  prefixCode: string
  level?: string
  parentId?: string
  parentName?: string
  childList?: treeItem[]
  canShow?: boolean // 树节点是否可见
  canAddProduct?: boolean // 树节点是否可以新增物料
  source?: string
  frontendHintText?: string // 四级类目前台提示文案
}
// 类型
interface TreeData {
  treeList: treeItem[]
  loading: boolean
}
// 默认数据
const defaultState: TreeData = {
  treeList: [],
  loading: false,
}
export default function reducer(
  state = defaultState,
  action: { type: string; value: any },
) {
  const arr = { ...state }
  switch (action.type) {
    case TREE_TYPE.SETTREELIST:
      arr.treeList = action.value
      return arr
    case TREE_TYPE.SET_TREE_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}
// 设置tree数据
export const setTreeAction = (param: treeItem[]) => ({
  type: TREE_TYPE.SETTREELIST,
  value: param,
})

export const getTreeAction = (param?: string) => ({
  type: TREE_TYPE.GET_TREE_DATA,
  value: param,
})

// 设置tree loading
export const setTreeLoadingAction = (param: boolean) => ({
  type: TREE_TYPE.SET_TREE_LOADING,
  value: param,
})
// action 类型定义
export const TREE_TYPE = {
  SETTREELIST: 'set_treeList',
  GET_TREE_DATA: 'get_treeList',
  SET_TREE_LOADING: 'SET_TREE_LOADING',
}
export interface treeItem {
  id: string
  name: string
  prefixCode: string
  level?: string
  parentId?: string
  parentName?: string
  childList?: treeItem[]
  canShow?: boolean // 树节点是否可见
  canAddProduct?: boolean // 树节点是否可以新增物料
  source?: string
  frontendHintText?: string // 四级类目前台提示文案
}
// 类型
interface TreeData {
  treeList: treeItem[]
  loading: boolean
}
// 默认数据
const defaultState: TreeData = {
  treeList: [],
  loading: false,
}
export default function reducer(
  state = defaultState,
  action: { type: string; value: any },
) {
  const arr = { ...state }
  switch (action.type) {
    case TREE_TYPE.SETTREELIST:
      arr.treeList = action.value
      return arr
    case TREE_TYPE.SET_TREE_LOADING:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}
// 设置tree数据
export const setTreeAction = (param: treeItem[]) => ({
  type: TREE_TYPE.SETTREELIST,
  value: param,
})

export const getTreeAction = (param?: string) => ({
  type: TREE_TYPE.GET_TREE_DATA,
  value: param,
})

// 设置tree loading
export const setTreeLoadingAction = (param: boolean) => ({
  type: TREE_TYPE.SET_TREE_LOADING,
  value: param,
})
